import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const FlatRegisters = createAsyncThunk(
    "dummyData/FlatRegister",
    async (formData) => {
  
      const response = await axios.post(
        `${BASE_URL}/add-flat`,
          formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            // Authorization: "Bearer " + token,
          },
        }
      );
  
      return response;
    }
  );
  



const FlatRegister = createSlice({
    name: "flatRegister",
    initialState: {
        loading: false,
        FlatRegister: [],
        error: ""
    },
    extraReducers: {
        [FlatRegisters.fulfilled]: (state, action) => {
            state.FlatRegister = action.payload;
            state.loading = false;
        },
        [FlatRegisters.pending]: (state) => {
            state.loading = true;
        },
        [FlatRegisters.rejected]: (state, action) => {
            state.error = action.error.message;
        },
    }
});
export default FlatRegister.reducer;